import React from "react";
import {IconUser, Spinner} from "@seismic/mantle";

export const SeismicEmployee = () => {
    return <img height={16} width={16} src="https://www.seismic.com/favicon.ico" alt="seismic logo" />
}

export const Customer = () => {
    return <IconUser size={16} />
}